<div class="camera-answer">
  <app-icon [size]="'24'" [glyph]="'camera'"></app-icon>
  <span *ngIf="count" class="camera-answer__meta">({{ count }} шт)<ng-container *ngIf="withComment"> + комментарий</ng-container></span>
</div>
